export const COMMON_SECRET = "Wmfd2893gb7";
